import React from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import moment from 'moment';
import IconButton from 'components/common/IconButton';
import Flex from 'components/common/Flex';

const CustomerCarePeriod = ({ customerCarePeriodList, setAddCarePeriod }) => {
  const columns = [
    {
      accessorKey: 'start',
      header: 'Start',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { startDate } = original;
        return (
          <h5 className="mb-0 fs-10">
            {moment(startDate).format('MMMM DD YYYY hh:mm a')}
          </h5>
        );
      }
    },
    {
      accessorKey: 'end',
      header: 'End',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { endDate } = original;
        return (
          <h5 className="mb-0 fs-10">
            {moment(endDate).format('MMMM DD YYYY hh:mm a')}
          </h5>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data: customerCarePeriodList,
    columns,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 10
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <Card className="mb-3">
          <Card.Header>
            <Flex justifyContent={'between'}>
              <h5>Add Care Period</h5>

              <IconButton
                variant="primary"
                iconClassName="me-2"
                icon="plus"
                size="sm"
                className="mb-2 mx-2"
                onClick={() => {
                  setAddCarePeriod(true);
                }}
              >
                Create
              </IconButton>
            </Flex>
          </Card.Header>
          <Card.Body className="p-0">
            <AdvanceTable
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                size: 'sm',
                striped: true,
                className: 'fs-10 mb-0 overflow-hidden'
              }}
            />
          </Card.Body>
          <Card.Footer>
            <div className="mt-3">
              <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
            </div>
          </Card.Footer>
        </Card>
      </AdvanceTableProvider>
    </>
  );
};

CustomerCarePeriod.propTypes = {
  customerCarePeriodList: PropTypes.any,
  setAddCarePeriod: PropTypes.any
};

export default CustomerCarePeriod;
